// extracted by mini-css-extract-plugin
module.exports = {"name_container":"StudentNameComponent_name_container___VDK_","student_name":"StudentNameComponent_student_name__2Cq8P","avatar":"StudentNameComponent_avatar__U85vT"};